import { Box } from '@chakra-ui/react';

export const UnreadDot = ({ isHidden }: { isHidden: boolean }) => {
  return (
    <Box
      data-testid="unread-dot"
      position="absolute"
      right={1}
      borderRadius="50%"
      backgroundColor="B.0"
      height={2}
      width={2}
      minWidth={2}
      minHeight={2}
      opacity={isHidden ? 0 : 1}
      top="calc(50% - 4px)"
      transition="opacity ease-in-out 600"
    />
  );
};
